import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

const Container = styled.div`
  grid-area: icon;
  align-self: center;
  justify-self: center;
`;

const IconLogo = styled(Icon)`
  font-size: 12px;
`;

export default ({ name }) => (
  <Container>
    <IconLogo name={name || 'tag'} />
  </Container>
);
